module.exports = __webpack_public_path__ + "img/aboutUs_sofa.b9ad403f.jpg";